import { useTranslation } from 'next-i18next';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { TWishlistSelectedItems } from 'fdr/components/candidate/fdr-wishlist/fdr-wishlist-selected-items-context';
import { FdrWishlistItemFragment } from 'fdr/schemas/fragment/wishlist/fdr-wishlist.generated';
import {
  COMPARE_ITEMS_COUNT_DESKTOP,
  COMPARE_ITEMS_COUNT_MOBILE,
} from './fdr-wishlist.constants';

type SelectOptionsType = {
  value: string;
  label: string;
};

const DESKTOP_OFFERS_LIMIT = 2;
const MOBILE_OFFERS_LIMIT = 1;

export default function useWishlistCompareOptions(
  items: FdrWishlistItemFragment[],
  selectedItems: TWishlistSelectedItems
): Array<SelectOptionsType[]> {
  const { mobile } = useDeviceType();
  const [t] = useTranslation('wishlist');

  const offersLimit = mobile ? MOBILE_OFFERS_LIMIT : DESKTOP_OFFERS_LIMIT;
  const hideBtnNeeded = items.length > offersLimit;

  const pureOptions =
    items?.map(it => {
      return { value: it.product.id, label: it.product.name };
    }) || [];

  return Array.from({
    length: mobile ? COMPARE_ITEMS_COUNT_MOBILE : COMPARE_ITEMS_COUNT_DESKTOP,
  }).map((_, index) => {
    if (items.length <= index) return [];

    const hideOfferTranslate = selectedItems[index]
      ? t('wishlist:hideOffer.option')
      : t('wishlist:hideOffer.select');

    return hideBtnNeeded
      ? [{ value: '', label: hideOfferTranslate }, ...pureOptions]
      : pureOptions;
  });
}
